import generationYBook from 'assets/images/generationY.png';
import generationYBookOverview from 'assets/images/booksOverview/generationY.png';

import { FLIP_BOOK, GIFT_BOOK, FLIP_BOOKS } from '../const';

import { getFlipBookPurchases } from './utils';

const generationY = {
  book: {
    id: 'generation-y',
    format: FLIP_BOOKS,
    title: 'Investing money for Generation Y',
    subtitle: 'Smart investing for 20- to 40-year-olds',
    videos: 'Erwin W. Heri and Iwan Brot',
    layoutAndProduction: 'Eric Marschall and Hanspeter Frey',
    scope: { pages: 16, videos: 12 },
    price: [18, 22],
    introductions: ['Introduction Generation Y'],
    image: generationYBook,
    overviewImg: generationYBookOverview,
  },
  bookIds: [16, 17],
  getDefaultOption: ({ isPremium, isBasic }) => (isBasic && 1) || (!isPremium && 2) || 0,
  getDefaultStrictMode: ({ isPremium, isBasic }) => Boolean(isBasic || isPremium),
  orderOptions: [FLIP_BOOK, GIFT_BOOK],
  purchases: getFlipBookPurchases([18, 22], [17, 16]),
};

export default generationY;
